// need to be put on each page even thoug it's global otherwise card-profile doesnt work anymore
// export { default as AlgoliaList } from "../algoliaList";
export { default as ArchiveObservatoire } from "../archiveObservatoire";
export { default as Form } from "../form";
export { default as FormQualification } from "../formQualification";
export { default as FormValidation } from "../formValidation";
export { default as Modal } from "../modal";
export { default as ModalControl } from "../modalControl";
